<sd-title
  [titleLevel]="2"
  class="is-main"
  [titleThemesConfig]="brandThemesEnum.brand"
  customClass="brand--h3 is-semi-bold"
>
  {{ 'account.title' | translate }}
</sd-title>

<sd-border-wrapper [titleLevel]="1">
  <sd-title [titleLevel]="2" customClass="brand--h5 is-regular">
    {{ 'account.myId' | translate }}
  </sd-title>
  <form [formGroup]="userForm">
    <fieldset>
      <div class="c__form-wrapper">
        <sd-form-input
          [labelTitle]="'forms.user.email' | translate"
          [formControl]="userForm.controls.email"
        />
        <sd-form-input
          [labelTitle]="'forms.user.password' | translate"
          [formControl]="userForm.controls.password"
          type="password"
        />
      </div>
      <div class="c__actions">
        <button sd-button (click)="editAccount()">
          <span> {{ 'forms.user.actions.editId' | translate }} </span>
        </button>
      </div>
    </fieldset>
  </form>
</sd-border-wrapper>

<sd-border-wrapper [titleLevel]="1">
  <sd-title [titleLevel]="2" customClass="brand--h5 is-regular">
    {{ 'account.myInfo' | translate }}
  </sd-title>
  <form [formGroup]="userInfoForm">
    <fieldset>
      <div class="c__form-wrapper">
        <sd-form-input
          [formControl]="userInfoForm.controls.firstName"
          [labelTitle]="'forms.user.firstName' | translate"
          [placeholder]="'forms.user.firstNamePlaceholder' | translate"
        >
          <ng-container sd-message>
            <sd-form-error
              errorKey="required"
              [errorLabel]="'forms.generic.message' | translate"
              [control]="userInfoForm.get('firstName')"
            />
          </ng-container>
        </sd-form-input>

        <sd-form-input
          [formControl]="userInfoForm.controls.lastName"
          [labelTitle]="'forms.user.lastName' | translate"
          [placeholder]="'forms.user.lastNamePlaceholder' | translate"
        >
          <ng-container sd-message>
            <sd-form-error
              errorKey="required"
              [errorLabel]="'forms.generic.message' | translate"
              [control]="userInfoForm.get('lastName')"
            />
          </ng-container>
        </sd-form-input>
      </div>
      <div class="c__form-wrapper">
        <sd-form-input
          [formControl]="userInfoForm.controls.birthdate"
          [labelTitle]="'forms.user.birthDate' | translate"
          [placeholder]="'forms.user.birthDatePlaceholder' | translate"
          type="date"
        >
          <ng-container sd-message>
            <sd-form-error
              errorKey="required"
              [errorLabel]="'forms.generic.message' | translate"
              [control]="userInfoForm.get('birthdate')"
            />
          </ng-container>
        </sd-form-input>
        <sd-form
          select
          [items]="genders"
          [formControl]="userInfoForm.controls.gender"
          valueKey="value"
          libelleKey="label"
          [labelTitle]="'forms.user.gender' | translate"
          [placeholder]="'forms.user.genderPlaceholder' | translate"
          [selectedValue]="selectedGender"
          [required]="true"
        >
          <ng-container sd-message>
            <sd-form-error
              errorKey="required"
              [errorLabel]="'forms.generic.message' | translate"
              [control]="userInfoForm.get('gender')"
            />
          </ng-container>
        </sd-form>
        <sd-form-input
          [formControl]="userInfoForm.controls.householdMembers"
          [labelTitle]="'forms.user.householdMembers' | translate"
          [placeholder]="'forms.user.householdMembersPlaceholder' | translate"
          [required]="true"
        >
          <ng-container sd-message>
            <sd-form-error
              errorKey="required"
              [errorLabel]="'forms.generic.message' | translate"
              [control]="userInfoForm.get('householdMembers')"
            />
          </ng-container>
        </sd-form-input>
      </div>
      <p class="c__description">
        {{ 'account.legalNotice' | translate }} {{ 'account.manageMyDataRight' | translate }}
        <a [routerLink]="urlContactUs">
          {{ 'account.manageMyData' | translate }}
        </a>
      </p>
      <div class="c__actions">
        <button sd-button (click)="editInfo()">
          <span>{{ infoButton }}</span>
        </button>
      </div>
    </fieldset>
  </form>
</sd-border-wrapper>

@if (addressesCard?.length > 0) {
  <sd-border-wrapper>
    <sd-title [titleLevel]="2" customClass="brand--h5 is-regular">
      {{ 'account.myAddresses' | translate }}
    </sd-title>
    <ul class="c__adresses is-s" sd-list-inline>
      @for (address of addressesCard; track address) {
        <li>
          @if (!!address) {
            <sd-address-card
              [address]="address"
              (edit)="editAddress(address)"
              [canChooseOther]="false"
              (mainAddress)="mainAddress(address)"
            />
          }
        </li>
      }
    </ul>
    <p class="c__description">{{ 'account.address.description' | translate }}</p>
  </sd-border-wrapper>
}

<div class="c__actions-template">
  <button sd-button (click)="addAddress()">
    <span> {{ 'forms.address.actions.create' | translate }} </span>
  </button>
</div>

@if (isLoading) {
  <div sd-loader></div>
}

@defer (when isEditInfoModalOpened) {
  <sd-modal-default
    [(isOpened)]="isEditInfoModalOpened"
    [noPadding]="false"
    [modalTitleLevel]="4"
    [modalTitle]="titleModal"
    (isOpenedChange)="onAddressModalClose($event)"
  >
    @if (isEditInfoModalOpened) {
      <wc-edit-address
        [fromMyAccount]="true"
        [hasBorder]="false"
        [addressForm]="addressFormGroup"
        [data]="addressEdited"
        class="form-field-vertical"
        [isLoading]="isLoadingModal"
        [customAddressForm]="addressForm"
        (editFormClosed)="closeEditAddress($event)"
        (addressSaved)="savedAddress($event)"
        (addressDeleted)="deletedAddress($event)"
      />
    }
  </sd-modal-default>
}

@defer (when isConfirmModalOpened) {
  <sd-modal-default
    [(isOpened)]="isConfirmModalOpened"
    [noPadding]="true"
    [modalTitleLevel]="4"
    [modalTitle]="'account.address.mainModal.confirmTitle' | translate"
  >
    <div sd-modal-body>
      @if (isLoadingModalConfirm) {
        <div sd-loader></div>
      }
      <div>{{ 'account.address.mainModal.confirmationText' | translate }}</div>
      <footer class="c__modal-actions" sd-modal-footer>
        <a sd-button (click)="cancelSwitch()" [isSecondary]="true">
          {{ 'account.address.mainModal.cancel' | translate }}
        </a>
        <button sd-button (click)="confirmMainAddress()">
          <span>{{ 'account.address.mainModal.confirm' | translate }}</span>
        </button>
      </footer>
    </div>
  </sd-modal-default>
}

@defer (when isEditAccountModalOpened) {
  <sd-modal-default
    [(isOpened)]="isEditAccountModalOpened"
    [modalTitle]="'account.editModal.title' | translate"
    [modalTitleLevel]="4"
    [noPadding]="true"
  >
    @if (!!myAccountUrl) {
      <iframe
        [src]="myAccountUrl"
        wcIframeResizer
        width="100%"
        style="border: none; min-height: 500px"
      ></iframe>
    }
  </sd-modal-default>
}